import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock, Instagram, Linkedin, Facebook, Twitter } from "lucide-react";
import { COMPANY } from "@/data/site";
import privacyPolicy from "@/components/PrivacyPolicy";
const QUICK = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/categories", label: "Categories" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms & Conditions" },
];

const PRODUCT_CATS = ["Signage", "Printing", "Promotional Products", "Display Stands", "Acrylic Products"];
const openEmail = () => {
  window.location.href = "mailto:printzone.gcc@gmail.com";
};

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F172A] text-white pt-20 pb-10">
      <div className="pz-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <img src={COMPANY.logo} alt="Printzee" className="h-16 w-15 rounded-xl" />
              <div>
                <div className="font-display font-bold text-xl">
                  Printzee<span className="text-[#F59E0B]">.ae</span>
                </div>
                <div className="text-[11px] uppercase tracking-[0.22em] text-white/60">Branding · Print · Events</div>
              </div>
            </div>
            <p className="mt-6 text-white/65 leading-relaxed max-w-md">
              Printzee.ae delivers premium branding, printing, signage, display and event solutions for businesses across the UAE and worldwide.
            </p>
            <div className="mt-7 flex items-center gap-3">
              {[Instagram, Linkedin, Facebook, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#F59E0B] hover:text-[#0F172A] hover:border-[#F59E0B] transition-all"
                  aria-label="Social link"
                >
                  <Icon className="w-4 h-4" strokeWidth={1.6} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#F59E0B] font-semibold">Company</div>
            <ul className="mt-6 space-y-3">
              {QUICK.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-white/70 hover:text-white text-sm transition-colors">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#F59E0B] font-semibold">Products</div>
            <ul className="mt-6 space-y-3">
              {PRODUCT_CATS.map((p) => (
                <li key={p}>
                  <Link to="/categories" className="text-white/70 hover:text-white text-sm transition-colors">{p}</Link>
                </li>
              ))}
            </ul>
          </div>

         <div className="md:col-span-4">
  <div className="text-[11px] uppercase tracking-[0.22em] text-[#F59E0B] font-semibold">
    Location & Support
  </div>

  <ul className="mt-6 space-y-4 text-sm">
    {/* Location */}
    <li>
      <a
        href="https://maps.google.com/?q=Deira,+Dubai,+UAE"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-start gap-3 text-white/80 hover:text-white transition-colors"
      >
        <MapPin
          className="w-4 h-4 mt-1 text-white/60"
          strokeWidth={1.6}
        />
        <span>Printzee.ae · 707, BMI building, Bank Street, Bur Dubai, Dubai-UAE</span>
      </a>
    </li>

    {/* Email */}
  <li>
  <a
    href="https://mail.google.com/mail/u/0/?fs=1&to=printzone.gcc@gmail.com&tf=cm"
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-start gap-3 text-white/80 hover:text-white transition-colors cursor-pointer"
  >
    <Mail
      className="w-4 h-4 mt-1 text-white/60"
      strokeWidth={1.6}
    />
    <span>printzone.gcc@gmail.com</span>
  </a>
</li>

    {/* Phone */}
    <li>
      <a
        href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
        className="flex items-start gap-3 text-white/80 hover:text-white transition-colors"
      >
        <Phone
          className="w-4 h-4 mt-1 text-white/60"
          strokeWidth={1.6}
        />
        <span>{COMPANY.phone}</span>
      </a>
    </li>
  </ul>

  {/* Map */}
  <div className="mt-5 rounded-2xl overflow-hidden border border-white/10">
    <a
      href="https://maps.google.com/?q=Deira,+Dubai,+UAE"
      target="_blank"
      rel="noopener noreferrer"
      className="block"
    >
      <iframe
        title="Printzee location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57728.74162553496!2d55.3256035!3d25.26902615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f434f37cdae93%3A0xde756363a1b78491!2sDeira%20-%20Dubai!5e0!3m2!1sen!2sae!4v1781274538720!5m2!1sen!2sae"
        width="100%"
        height="150"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ border: 0 }}
      />
    </a>
  </div>
</div>
        </div>

        <div className="pt-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="text-white/55 text-sm">© {new Date().getFullYear()} Printzee.ae — All Rights Reserved.</div>
          <div className="text-white/55 text-sm flex items-center gap-5">
            <a href="/privacy-policy" className="hover:text-white">Privacy Policy</a>
            <a href="/terms" className="hover:text-white">Terms & Conditions</a>
          
          </div>
        </div>
      </div>
    </footer>
  );
}
